import React from 'react';
import PropTypes from 'prop-types';
import { statusOptions, statusColors } from './statusOptions';
import Badge from 'components/Badge';

const StatusBadge = ({ className, status }) => (
  <Badge
    text={status}
    colorClass={statusColors[status]}
    className={className}
  />
);

StatusBadge.propTypes = {
  className: PropTypes.string,
  status: PropTypes.oneOf(statusOptions),
};

export default StatusBadge;
